<template>
	<div class="panebox">

		<div class="pane">
			<div class="pane_tit">巡防任务</div>
			<div class="pane_cont">
				<el-row :gutter="20">
					<el-col :span="8">
						<div>负责人：<span>{{ taskInfo.gridmanname }}</span></div>
					</el-col>
					<el-col :span="24">
						<div>巡防地址：<span>{{ taskInfo.housename }}</span></div>
					</el-col>
					<el-col :span="24">
						<div id="grouprentalTaskMap" style="height: 200px; width: 98%; margin: 10px auto 20px;"></div>
					</el-col>
					<el-col :span="8">
						<div>巡防次数：<span>{{ taskInfo.totalcount }}</span></div>
					</el-col>
					<el-col :span="8">
						<div>问题上报次数：<span>{{ taskInfo.problemcount }}</span></div>
					</el-col>
				</el-row>
			</div>
		</div>

		<div class="pane" v-if="flowList.length">
			<div class="pane_tit">巡防流水</div>
			<div class="pane_cont">
				<div class="flow">
					<div class="flowitem" v-for="item in flowList" :key="item.id">
						<div class="icon"></div>
						<div class="desc">
							<div style="align-items: center;">
								<div class="filed">巡防时间：</div>
								<div>{{ item.create_time }}</div>
								<div v-if="item.gridman_name">，{{ item.gridman_name }}</div>
								<div v-if="item.problem == 1">，<span style="color: #ee9934 ">发现问题</span></div>
								<i @click="xianshi(item.problem_xy)" style="margin-left: 10px;cursor: pointer;" class="el-icon-location-information"></i>
							</div>
							<div v-if="item.problem_description">
								<div class="filed">问题描述：</div>
								<div style="color: #dd4a68;">{{ item.problem_description }}</div>
							</div>
							<div v-if="item.problem_attachment_path.length>0">
								<div class="filed">相关图片：</div>
								<div class="imgs">
									<el-image style="height: 90px; width: auto; margin-right: 10px;"
										v-for="(imgurl,index) in item.problem_attachment_path" :key="index"
										:src="imgurl" :preview-src-list="item.problem_attachment_path">
									</el-image>
								</div>
							</div>

							<!-- 处理 -->
							<div v-if="item.deal_manname">
								<div class="filed">处理人：</div>
								<div>{{ item.deal_manname }}</div>
							</div>
							<div v-if="item.deal_description">
								<div class="filed">处理描述：</div>
								<div style="color: #dd4a68;">{{ item.deal_description }}</div>
							</div>
							<div v-if="item.deal_attachment_path.length">
								<div class="filed">相关图片：</div>
								<div class="imgs">
									<el-image style="height: 90px; width: auto; margin-right: 10px;"
										v-for="(imgurl,index) in item.deal_attachment_path" :key="index" :src="imgurl"
										:preview-src-list="item.deal_attachment_path">
									</el-image>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="pagebox">
					<el-pagination :hide-on-single-page="true" background @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next"
						:total="totalRow">
					</el-pagination>
				</div>
			</div>

		</div>
		<el-dialog append-to-body title="巡防地点" :close-on-click-modal="false" :visible.sync="detailVisible" width="1000px">
			<div id="grouprentalTaskMap2" style="height: 400px; width: 98%; margin: 10px auto 20px;"></div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		lazyAMapApiLoaderInstance
	} from 'vue-amap';
	import {
		taskDetail,
		taskFlow
	} from '@/api/groupRentalTask'
	import {
		periodOptions
	} from '../dict'
	export default {
		name: "detail",
		components: {},
		props: {
			taskId: {
				type: Number,
				default: null
			}
		},
		data() {
			return {
				detailVisible: false,
				currentPage: 1,
				pageSize: 10,
				totalRow: 0,
				periodOptions,
				taskInfo: {},
				flowList: []
			}
		},
		watch: {
			taskId: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.getInfo();
						this.getFlows();
					}
				},
				immediate: true
			}
		},
		created() {},
		mounted() {},
		computed: {},
		methods: {
			xianshi(a){
				let that = this;
				let center = a.split(',');
				that.detailVisible = true;
				lazyAMapApiLoaderInstance.load().then(() => {
					let map = new AMap.Map('grouprentalTaskMap2', {
						center,
						zoom: 20,
					})
				
					let marker = new AMap.Marker({
						position: center,
						offset: new AMap.Pixel(-13, -30)
					});
					marker.setMap(map);
				})
			},
			//加载地图
			getmap(center) {
				lazyAMapApiLoaderInstance.load().then(() => {
					let map = new AMap.Map('grouprentalTaskMap', {
						center,
						zoom: 20,
					})

					let marker = new AMap.Marker({
						position: center,
						offset: new AMap.Pixel(-13, -30)
					});
					marker.setMap(map);
				})
			},
			//获取任务详情
			getInfo() {
				taskDetail({
					id: this.taskId
				}).then(res => {
					if (res.result == 200) {
						console.log(res)
						this.taskInfo = res.detail;
						let center = this.taskInfo.jobxy ? this.taskInfo.jobxy.split(',') : []
						this.getmap(center)
					} else {
						this.$message.warning(res.description)
					}
				})
			},
			//获取任务流水
			getFlows() {
				taskFlow({
					taskId: this.taskId,
					page: this.currentPage,
					pageSize: this.pageSize
				}).then(res => {
					if (res.result == 200) {
						console.log(res)
						this.flowList = res.detail.list;
						this.totalRow = res.detail.totalRow;
					} else {
						this.$message.warning(res.description)
					}
				})
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getFlows();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pane {
		margin-bottom: 30px;
		border: 1px solid #ddd;
		box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);

		.pane_tit {
			padding: 10px 20px;
			border-bottom: 1px solid #ddd;
			background: #f9f9f9;
			font-size: 16px;
			color: #333;
		}

		.pane_cont {
			padding: 20px;
			background: #fff;

			.el-row {
				>div {
					margin-bottom: 14px;
					font-weight: bold;
					color: #333;

					span {
						font-weight: normal;
						color: #666;
					}
				}
			}

			.flow {
				max-height: 360px;
				overflow: auto;
			}

			.flowitem {
				position: relative;
				padding-left: 30px;

				.icon {
					position: absolute;
					height: 100%;
					background: #e4e7ed;
					width: 1px;
					top: 15px;

					&::before {
						position: absolute;
						content: '';
						left: 0;
						top: 0;
						transform: translate(-50%, -50%);
						width: 15px;
						height: 15px;
						background: #e4e7ed;
						border-radius: 50%;
					}
				}

				&:last-child {
					.icon {
						height: 0;
					}
				}

				.desc {
					padding: 5px 30px 40px;
					min-height: 40px;
					line-height: 1.6em;

					>div {
						display: flex;
						margin-bottom: 5px;

						.filed {
							width: 120px;
							text-align: right;
						}
					}

					.imgs {
						display: flex;

						img {
							height: 90px;
							width: auto;
							margin-right: 10px;
						}
					}
				}
			}
		}
	}

	.pagebox {
		padding-top: 20px;
	}
</style>